import {Component, EventEmitter, inject, Input, OnInit, Output, signal} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {environment} from "projects/store/src/environments/environment";
import {UserValidatorService} from "projects/store/src/app/services/api/v1/user-validator.service";
import {ActivatedRoute} from "@angular/router";
import {filter, take} from "rxjs/operators";

@Component({
  selector: 'app-sales-additional-information-field-phone',
  templateUrl: './sales-additional-information-field-phone.component.html'
})
export class SalesAdditionalInformationFieldPhoneComponent implements OnInit {
  country: any = environment.global.country;

  @Input() form!: FormGroup;
  @Input() field: any;
  @Input() variant: 'v2' | 'v3' = 'v2';
  @Output() saveEvent = new EventEmitter();
  isSubmitted = signal(false);
  requestId!: string

  userValidatorService = inject(UserValidatorService);
  private readonly route = inject(ActivatedRoute);

  ngOnInit() {
    this.requestId = this.route.snapshot.params['request_id'];
    this.form.addControl(`${this.field.key}`, new FormControl(this.field.value, {
      validators: [Validators.required, Validators.minLength(environment.global.country.minPhoneNumberCharacters),
        Validators.maxLength(environment.global.country.maxPhoneNumberCharacters)],
      asyncValidators: [this.userValidatorService.phoneServiceVerification(), this.userValidatorService.phoneServiceExistValidator(this.requestId, this.field.key)],
      updateOn: 'blur'
    }));
  }

  save() {
    this.isSubmitted.set(true);
    const control = this.form.get(this.field.key);

    control?.markAsTouched();
    control?.updateValueAndValidity({ onlySelf: true, emitEvent: true });

    if (control?.pending) {
      control.statusChanges
        .pipe(
          filter(status => status !== 'PENDING'),
          take(1)
        )
        .subscribe(status => {
          if (status === 'VALID' && control.errors === null) {
            this.emitSave();
          }
        });
    } else if (control?.valid && control.errors === null) {
      this.emitSave();
    }
  }



  private emitSave() {
    this.saveEvent.emit({id: this.field.id, value: this.form.get(this.field.key)?.value});
  }

  get f() {
    return this.form.controls;
  }
}
